import isBrowser from './isBrowser';
import { getSearch } from './location';

const getParamFromUrl = (param: string): string => {
  if (!isBrowser()) return '';
  const queryString = getSearch();
  const urlParams = new URLSearchParams(queryString);
  const paramValue = urlParams.get(param);
  return paramValue || '';
};

export default getParamFromUrl;
